import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "item-secondary-title py-2" }, "Thank you for confirming your insurance", -1)
const _hoisted_2 = { class: "item-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "item-content" }, [
  /*#__PURE__*/_createTextVNode(" If this email is wrong, please call us on "),
  /*#__PURE__*/_createElementVNode("a", { href: "tel:0800 336 338" }, "0800 336 338"),
  /*#__PURE__*/_createTextVNode(" to update the details. ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "item-content" }, " You have a 30 day free look period, which lets you cancel the policy for a full refund. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(" We'll email the Policy document, Policy schedule and payment details to "),
      _createElementVNode("b", null, _toDisplayString(_ctx.insuredPersonEmail) + ".", 1)
    ]),
    _hoisted_3,
    _hoisted_4
  ]))
}